import { Box } from '@material-ui/core';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../hooks/useGeneralTasksStore';
import { useEffect, useState } from 'react';
import { generalTaskStatusOptions, LOAN_RELATED_DOCUMENTS, LOAN_RELATED_DOCUMENTS_ID } from '../utils/generalTasksConstants';
import { AddLoanTaskDialog } from './addLoanTask/addLoanTaskDialog';
import { Category } from '@material-ui/icons';
type ButtonProps = {
  loanId: any,
  buttonStyle?: any
}
export const AddNewTaskButton = observer(({ loanId, buttonStyle }: ButtonProps) => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore, globalStore } = generalTasksStore;
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  useEffect(() => {
    generalTasksStore.fetchUserInfoAndAssigneeOptions(loanId);
  }, [loanId])

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          size="small"
          className={buttonStyle}
          onClick={() => setAddDialogOpen(true)}
          color="primary"
          testId="create_task">
          Create task
        </Button>
      </Box>
      <AddLoanTaskDialog
        open={addDialogOpen}
        loanId={loanId}
        handleClose={() => {
          setAddDialogOpen(false)
          generalTasksStore.applyFilters();
        }}
        sectionName={globalStore.isInternalPortal ? undefined : LOAN_RELATED_DOCUMENTS}
        sectionId={globalStore.isInternalPortal ? undefined : LOAN_RELATED_DOCUMENTS_ID}
        options={editTaskStore.loanTaskSectionNames.map(category => ({ value: category.taskCategoryId, label: category.displayName }))}
      />
    </>
  );
});
